import { useState, useEffect, useCallback, useRef } from 'react'

function useLocation() {
  const [lokacija, setLokacija] = useState(null)
  const [klaida, setKlaida] = useState(null)
  const [kraunasi, setKraunasi] = useState(true)
  const lokacijaRef = useRef(null)

  const patikrinti = useCallback(() => {
    if (!navigator.geolocation) {
      setKlaida('Tavo naršyklė nepalaiko GPS')
      setKraunasi(false)
      return
    }
    setKraunasi(true)
    setKlaida(null)
    navigator.geolocation.getCurrentPosition(
      (pozicija) => {
        const vieta = { lat: pozicija.coords.latitude, lng: pozicija.coords.longitude }
        lokacijaRef.current = vieta
        setLokacija(vieta)
        setKraunasi(false)
      },
      () => {
        setKlaida('Nepavyko gauti lokacijos — patikrink leidimus')
        setKraunasi(false)
      },
      { timeout: 8000, maximumAge: 60000 }
    )
  }, [])

  useEffect(() => {
    // Užklausiam užsikrovus (native leidimo langas, jei dar neapsispręsta)
    patikrinti()

    // Grįžus į programėlę (pvz. iš nustatymų), jei lokacijos vis dar nėra —
    // užklausiam iš naujo. Taip po leidimo įjungimo app iškart pasitikrina.
    const grizus = () => {
      if (document.visibilityState === 'visible' && !lokacijaRef.current) {
        patikrinti()
      }
    }
    document.addEventListener('visibilitychange', grizus)
    return () => document.removeEventListener('visibilitychange', grizus)
  }, [patikrinti])

  return { lokacija, klaida, kraunasi, patikrinti }
}

export default useLocation
